import { For, JSX, splitProps } from 'cdui-js';

export const RadioGroup = <T, U extends JSX.Element>(
  props: JSX.HTMLAttributes<never> & {
    value: string | number;
    options: any[];
    change?: (e) => void;
  }
) => {
  const [localProps, restProps] = splitProps(props, ['value', 'options', 'change', 'class']);

  return (
    <div class={`flex gap-16px ${localProps.class || ''}`} {...restProps}>
      <For each={localProps.options}>
        {(item) => (
          <div class="flex align-center gap-8px" onclick={() => localProps.change(item.value)}>
            {localProps.value === item.value ? (
              // <svg
              //   width="18"
              //   height="18"
              //   viewBox="0 0 18 18"
              //   stroke="none"
              //   fill="none"
              //   xmlns="http://www.w3.org/2000/svg"
              // >
              //   <circle cx="9" cy="9" r="9" fill="#1B212D" />
              //   <circle cx="9" cy="9" r="4" fill="white" />
              // </svg>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                stroke="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9" r="9" fill="#1060FF" />
                <circle cx="9" cy="9" r="4" fill="white" />
              </svg>
            ) : (
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                stroke="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9" r="8.5" stroke="#E4E4E4" />
              </svg>
            )}

            <span>{item.label}</span>
          </div>
        )}
      </For>
    </div>
  );
};
